/**
 * Version de l'interface, injectée au BUILD de déploiement (VITE_APP_VERSION = dernier tag
 * et distance de commits en métadonnée de build, par exemple « v0.5.1+9 » — S21 : jamais versée
 * dans le patch, qui faisait reculer la version au tag suivant ; VITE_BUILD_DATE = date ET heure du déploiement, « YYYY-MM-DD HH:MM »). Sert à tracer
 * précisément quelle version est en ligne et QUAND elle a été déployée — affichée dans le pied de la
 * barre latérale. En dev (sans injection), retombe sur « dev ».
 */
const BUILD = import.meta.env['VITE_APP_VERSION'] ?? ''
const DATE = import.meta.env['VITE_BUILD_DATE'] ?? ''

/** Étiquette de version affichable, p. ex. « v0.5.1+9 » ou « dev ». */
export const APP_VERSION = BUILD ? (BUILD.startsWith('v') ? BUILD : `v${BUILD}`) : 'dev'

/** Horodatage du déploiement (« YYYY-MM-DD HH:MM ») ou chaîne vide si non injecté. */
export const BUILD_DATE = DATE
